import type { ReactNode } from 'react';

import type { TabOption } from '@/components/chariot-ui';
import { EvidenceImage } from '@/components/legacy-ui/EvidenceImage';

export function createImageSection(
  imageSource: unknown,
  registryKey: string,
  label: string = 'Uploaded Evidence'
): { section: ReactNode; tabOption: TabOption } | null {
  if (typeof imageSource !== 'string' || !imageSource.startsWith('blob:')) {
    return null;
  }

  return {
    section: (
      <EvidenceImage
        src={imageSource}
        altText="Evidence"
        registryKey={registryKey}
      />
    ),
    tabOption: { label, value: registryKey },
  };
}
